<app-popup-layout #modal>
  <div class="modal-container py-5 px-4">
    <section class="title">
      <p class="m-0 p-0">Welcome,</p>
      <p>{{ userService?.currentUser?.companyName }}</p>
      <p class="sub-title mt-4">
        Complete below steps to setup your eRUPI Voucher Account.
      </p>
    </section>
    <div class="stepper ms-3 mt-3">
      <!-- completed -->
      <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class="line"></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 created-title">Account Creation</p>
          <p class="created-sub-title">Your eRUPI Voucher account is created.</p>
        </div>
      </div>

      <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class="line"></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 content-title">Allocate Funds</p>
          <p class="content-subtitle">
            Your eRUPI Vouchers account balance is 0.00
          </p>
        </div>
      </div>

      <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class=""></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 content-title">Add Employee and Issue eRUPI Vouchers</p>
          <p class="content-subtitle">
            Send eRUPI Vouchers to Employee using 'Add eRUPI Voucher' option
          </p>
        </div>
      </div>

      <!-- <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class=""></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 content-title">Spending Allowance</p>
          <p class="content-subtitle">Your employee/s account is created</p>
        </div>
      </div> -->
    </div>

    <section class="d-flex justify-center">
      <!-- <button
        mat-flat-button
        color="accent"
        class="me-4"
        (click)="modal.dismiss()"
      >
        I’ll do it Later
      </button> -->

      <button mat-flat-button color="primary" (click)="onSettingUp(); modal.dismiss()">
        Okay
      </button>
    </section>
  </div>
</app-popup-layout>